/*
 * File: AsanaAddProject.tsx
 * Project: a-a
 * File Created: Thursday, 15th May 2025 11:33:21 pm
 * Author: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Last Modified: Saturday, 23rd August 2025 12:01:32 am
 * Modified By: Jackson Thounaojam (jackson.thounaojam@mutualmobile.com)
 * -----
 * Copyright 2020 - 2025 Mutual Mobile, Mutual Mobile
 */
import {
  Box,
  Chip,
  Divider,
  FormControl,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Radio,
  Select,
  Typography,
} from '@mui/material';
import React, { useEffect, useState } from 'react';
import CustomModal from '../../../shared/CustomModal/CustomModal';
import CustomDrawer from '../../../shared/CustomDrawer/CustomDrawer';
import zeplinColor from '../../../../theme/Color';
import CustomDatePicker from '../../../shared/CustomDatePicker/CustomDatePicker';
import dayjs, { Dayjs } from 'dayjs';
import CustomTextField from '../../../shared/CustomTextField/CustomTextField';
import { useInput } from '../../../../customHook/useInput';
import CustomButton from '../../../shared/CustomButton/CustomButton';
import { Constants } from '../../../../utilities/constants';
import KeyboardArrowDown from '@mui/icons-material/KeyboardArrowDown';
import { AsanaService } from '../../../../service/asana.service';
import CustomAlert from '../../../shared/CustomAlert/CustomAlert';
import CustomAlertContain from '../../../shared/CustomAlert/CustomAlertContain';

const MenuProps = {
  PaperProps: {
    sx: {
      borderRadius: '14px',
      // padding: '16px',
    },
  },
};

const AsanaAddProject = ({
  modalOpen,
  setModalOpen,
  data,
  getProjects,
  setMessage,
  setEditedProject,
}: {
  modalOpen: boolean;
  setModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
  getProjects?: () => void;
  data?: any;
  setMessage: React.Dispatch<React.SetStateAction<string>>;
  setEditedProject?: React.Dispatch<any>;
}) => {
  console.log(data);
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);
  const [selectedItems, setSelectedItems] = useState<{
    team: string[];
    privacy: string[];
  }>({
    team: data?.team?.gid ? [data?.team?.gid] : data?.team ? [data?.team?.id] : [],
    privacy: data?.privacySetting ? [data?.privacySetting] : data?.privacy ? [data?.privacy] : [],
  });
  const [team, setTeam] = useState<{ id: string; name: string }[]>();
  const {
    handleChange: handleProjectChange,
    handleBlur: handleProjectBlur,
    clearInput: clearProject,
    value: project,
    invalid: invalidProject,
    didChange: didProjectChange,
    setValue: setProjectChange,
    setDidChange: setDidProjectChange,
  } = useInput(data ? data?.name : '', (val) => (val?.trim().length ? true : false));
  const [date, setDate] = useState<Dayjs | null>(
    data?.dueDate && dayjs(data?.dueDate).date() ? dayjs(data?.dueDate) : null,
  );

  const privacyOptions = [
    {
      label: 'A&A Management Group',
      value: 'public_to_workspace',
      description: 'Everyone in your organization can find and access this project.',
    },
    {
      label: 'Shared with team',
      value: 'private_to_team',
      description: 'Only this team and invited members can find and access this project.',
    },
    {
      label: 'Private to members',
      value: 'private',
      description: 'Only invited members can find and access this project.',
    },
  ];
  const {
    handleChange: handleCommentChange,
    handleBlur: handleCommentBlur,
    clearInput: clearComment,
    value: comment,
    invalid: invalidComment,
    didChange: didCommentChange,
    setValue: setComment,
  } = useInput(data?.description ? data?.description : '', () => true);
  useEffect(() => {
    setSelectedItems({
      team: data?.team?.gid ? [data?.team?.gid] : data?.team ? [data?.team?.id] : [],
      privacy: data?.privacySetting ? [data?.privacySetting] : data?.privacy ? [data?.privacy] : [],
    });
    setProjectChange(data?.name);
  }, []);
  const editProject = async () => {
    try {
      setLoading(true);
      const res = await AsanaService.editAsanaProject(data?.id, {
        name: project,
        team: selectedItems?.team[0],
        privacy: selectedItems?.privacy[0],
        dueDate: date,
        description: comment,
      });
      setProjectChange('');
      setComment('');
      setSelectedItems({ team: [], privacy: [] });
      setModalOpen(false);
      getProjects && getProjects();
      setMessage('Edited project successfully');

      setEditedProject && setEditedProject(res.updatedProject);
    } catch (err) {
      console.log(err, 'errorrr');
      setError(true);
    } finally {
      setLoading(false);
    }
  };
  const createProject = async () => {
    try {
      setLoading(true);
      const res = await AsanaService.createAsanaProject({
        name: project,
        team: selectedItems?.team[0],
        privacy: selectedItems?.privacy[0],
        dueDate: date,
        description: comment,
      });
      setProjectChange('');
      setComment('');
      setSelectedItems({ team: [], privacy: [] });
      setModalOpen(false);
      getProjects && getProjects();
      setMessage('Created project successfully');
    } catch (err) {
      setError(true);
    } finally {
      setLoading(false);
    }
  };

  const onClose = (open: boolean) => (event: React.KeyboardEvent | React.MouseEvent) => {
    if (
      event.type === 'keydown' &&
      ((event as React.KeyboardEvent).key === 'Tab' ||
        (event as React.KeyboardEvent).key === 'Shift')
    ) {
      return;
    }
    setModalOpen(false);
  };
  const getTeams = async () => {
    try {
      const res = await AsanaService.getAsanaTeams();
      console.log(res);
      setTeam(res);
    } catch (err) {
      setError(true);
    }
  };

  const handleSelection = (item: any, type: string) => {
    console.log({ item });

    const key = type as keyof typeof selectedItems;
    if (Array.isArray(item)) {
      setSelectedItems((prev) => ({ ...prev, [key]: [...item] }));
    } else if (item?.target?.value) {
      const {
        target: { value },
      } = item;

      setSelectedItems((prev) => ({
        ...prev,
        [key]: typeof value === 'string' ? value.split(',') : value,
      }));
    } else {
      setSelectedItems((prev) => ({
        ...prev,
        [key]: [item],
      }));
    }
  };
  useEffect(() => {
    modalOpen && getTeams();
    if (!data?.id) {
      setProjectChange('');
      setComment('');
      setSelectedItems({ team: [], privacy: [] });
      setDidProjectChange(false);
    }
    if (data?.id) {
      setSelectedItems({
        team: data?.team?.gid ? [data?.team?.gid] : data?.team ? [data?.team?.id] : [],
        privacy: data?.privacySetting
          ? [data?.privacySetting]
          : data?.privacy
          ? [data?.privacy]
          : [],
      });
      setDate(dayjs(data?.dueDate).date() ? dayjs(data?.dueDate) : null);
      setComment(data?.description ? data?.description : '');
      setProjectChange(data ? data?.name : '');
    }
  }, [modalOpen]);
  const handleClose = () => {
    setError(false);
  };
  console.log(privacyOptions, selectedItems);
  return (
    <Box>
      {modalOpen && (
        <CustomDrawer state={modalOpen} onClose={onClose(false)}>
          <Box
            sx={{
              width: '492px',
              position: 'relative',
              overflowY: 'scroll',
              display: 'flex',
              flexDirection: 'column',
              gap: '24px',
              height: '100vh',
            }}
          >
            <Box
              sx={{
                position: 'sticky',
                top: 0,
                zIndex: 1000,
                backgroundColor: zeplinColor.Neutral1,
              }}
            >
              <Box
                sx={{
                  display: 'flex',
                  justifyContent: 'space-between',
                  padding: '40px 24px 24px 24px',
                }}
              >
                <Typography variant='heading2'>
                  {data?.id ? 'Edit Project' : 'New Project'}
                </Typography>

                <img
                  src={'/assets/close-icon.svg'}
                  width={24}
                  height={24}
                  alt='close'
                  style={{ cursor: 'pointer' }}
                  onClick={onClose(false)}
                />
              </Box>

              <Divider
                component='div'
                sx={{ borderColor: zeplinColor.Neutral5, position: 'relative' }}
              />
            </Box>
            <Box
              sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: '24px',
                padding: '0px 24px 24px 24px',
                flex: 1,
              }}
            >
              <CustomTextField
                style={{ width: '100%' }}
                onBlur={handleProjectBlur}
                onChange={handleProjectChange}
                name='Project Name'
                text={project}
                error={invalidProject && didProjectChange ? 'Please enter valid Project Name' : ''}
                label={'Project Name'}
                type='text'
                tabindex={1}
                required
              />
              <FormControl sx={{ width: '100%' }}>
                <InputLabel
                  id='demo-multiple-name-label'
                  sx={{
                    '&.Mui-focused': { color: zeplinColor.Neutral9 },
                  }}
                >
                  Team<span style={{ color: zeplinColor.Error }}>*</span>
                </InputLabel>
                <Select
                  labelId='demo-multiple-name-label'
                  id='demo-multiple-name'
                  // multiple
                  required={true}
                  value={selectedItems.team}
                  onChange={(e) => handleSelection(e, 'team')}
                  input={
                    <OutlinedInput
                      sx={{
                        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                          borderWidth: '1px',
                          color: zeplinColor.Neutral9,
                          borderColor: zeplinColor.Neutral9,
                        },
                      }}
                      label='Team'
                    />
                  }
                  renderValue={
                    (selected) =>
                      // (selected as string[]).map((val) => (
                      {
                        return selected?.length
                          ? team?.length && team.filter((val) => val.id === selected[0])[0]?.name
                          : '';
                      }
                    // ))
                  }
                  MenuProps={MenuProps}
                  IconComponent={KeyboardArrowDown}
                >
                  {team?.length &&
                    team.map((name) => (
                      <MenuItem key={name.id} value={name.id}>
                        <Radio
                          checked={
                            selectedItems?.team?.length
                              ? selectedItems?.team?.indexOf(name.id) > -1
                              : false
                          } // Check if this radio should be selected
                          sx={{
                            color: zeplinColor.BasicBlack,
                            '&.Mui-checked': {
                              color: zeplinColor.BasicBlack,
                            },
                          }}
                        />
                        {name.name}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>

              <FormControl sx={{ width: '100%' }}>
                <InputLabel
                  id='demo-multiple-name-label'
                  sx={{
                    '&.Mui-focused': { color: zeplinColor.Neutral9 },
                  }}
                >
                  Privacy<span style={{ color: zeplinColor.Error }}>*</span>
                </InputLabel>
                <Select
                  labelId='demo-multiple-name-label'
                  id='demo-multiple-name'
                  // multiple
                  required={true}
                  value={selectedItems.privacy}
                  onChange={(e) => handleSelection(e, 'privacy')}
                  input={
                    <OutlinedInput
                      sx={{
                        '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
                          borderWidth: '1px',
                          color: zeplinColor.Neutral9,
                          borderColor: zeplinColor.Neutral9,
                        },
                      }}
                      label='Privacy'
                    />
                  }
                  renderValue={
                    (selected) =>
                      // (selected as string[]).map((val) => (
                      {
                        return (
                          privacyOptions?.length &&
                          privacyOptions.filter((val) => val.value === selected[0])[0]?.label
                        );
                      }
                    // ))
                  }
                  MenuProps={MenuProps}
                  IconComponent={KeyboardArrowDown}
                >
                  {privacyOptions?.length &&
                    privacyOptions.map((name) => (
                      <MenuItem key={name.value} value={name.value}>
                        <Radio
                          checked={
                            selectedItems?.privacy?.length
                              ? selectedItems?.privacy?.indexOf(name.value) > -1
                              : false
                          } // Check if this radio should be selected
                          sx={{
                            color: zeplinColor.BasicBlack,
                            '&.Mui-checked': {
                              color: zeplinColor.BasicBlack,
                            },
                          }}
                        />
                        {name.label}
                      </MenuItem>
                    ))}
                </Select>
              </FormControl>
              <CustomDatePicker value={date} setValue={setDate} />
              <CustomTextField
                style={{ width: '100%' }}
                onBlur={handleCommentBlur}
                onChange={handleCommentChange}
                name='Project description'
                text={comment}
                error={''}
                label={'Project description'}
                type='text'
                tabindex={1}
                multiline
                // required
              />
            </Box>
            <Box
              sx={{
                width: '100%',
                position: 'sticky',
                bottom: '0px',
                margin: 'auto',
                zIndex: '100',
                padding: '24px',
                backgroundColor: zeplinColor.Neutral1,
              }}
            >
              <CustomButton
                disabled={
                  !project ||
                  !selectedItems?.team?.length ||
                  loading ||
                  !selectedItems.privacy?.length
                }
                onClick={() =>
                  !project ||
                  !selectedItems?.team?.length ||
                  loading ||
                  !selectedItems.privacy?.length
                    ? () => {}
                    : data
                    ? editProject()
                    : createProject()
                }
                variant='contained'
                color={'primary'}
                style={{
                  borderRadius: '14px',
                  height: 56,
                  width: '100%',
                  '&.Mui-focusVisible': { backgroundColor: '#333CAA' },
                }}
                textStyle={{ color: zeplinColor.Neutral1 }}
                text={
                  data?.id
                    ? loading
                      ? 'Saving'
                      : 'Save'
                    : loading
                    ? 'Creating Project'
                    : 'Create Project'
                }
                // tabindex={4}
              />
            </Box>
          </Box>
          <CustomAlert
            open={error ? true : false}
            handleClose={handleClose}
            message={
              <CustomAlertContain
                alert={
                  error
                    ? 'Something went wrong'
                    : data?.id
                    ? 'Edit successfully'
                    : 'Created project successfully'
                }
                alertIcon={
                  !error ? (
                    <img src='/assets/checkmark-green.png' width={24} height={24} />
                  ) : (
                    <img src='/assets/error.svg' width={24} height={24} />
                  )
                }
                error={!error ? false : true}
              />
            }
            error={!error ? false : true}
          />
        </CustomDrawer>
      )}
    </Box>
  );
};

export default AsanaAddProject;
